// import fetch from "auth/FetchInterceptor";
import { lossClient } from "api";

const workflowProcessService = {};

workflowProcessService.getWorkflowProcessList = function () {
  return lossClient({
    url: "/reference/workflowProcess",
    method: "get",
  });
};
// Service add work flow
workflowProcessService.addWorkflowProcess = function (data) {
  return lossClient({
    url: "/ProductWorkFlow/add",
    method: "post",
    headers: {
      "x-RequestId": data.id,
    },
    data: {
      ProductId: data.id,
      ProductWFs: data.ProductWFs,
      UserId: "Santani",
    },
  });
};

// Service Do Return work flow
workflowProcessService.doReturnWorkflowProcess = function (data) {
  return lossClient({
    url: "/ProductWorkFlow/Return",
    method: "put",
    headers: {
      "x-RequestId": data.id,
    },
    data: {
      UserId: "Santani",
    },
  });
};

// Service Reject work flow
workflowProcessService.rejectWorkflowProcess = function (data) {
  return lossClient({
    url: "/ProductWorkFlow/Reject",
    method: "put",
    headers: {
      "x-RequestId": data.id,
    },
    data: {
      Note: data.note,
    },
  });
};

// Service Edit work flow
workflowProcessService.editWorkflowProcess = function (data) {
  return lossClient({
    url: "/ProductWorkFlow/edit",
    method: "put",
    headers: {
      "x-RequestId": data.id,
    },
    data: {
      ProductWFs: data.ProductWFs,
      UserId: "Santani",
    },
  });
};
// Service Delete work flow
workflowProcessService.deleteWorkflowProcess = function (data) {
  return lossClient({
    url: "/ProductWorkFlow/Delete",
    method: "delete",
    headers: {
      "x-RequestId": data.id,
    },
    data: {
      ProductId: data.id,
      ProductWFs: data.ProductWFs,
      UserId: "Santani",
    },
  });
};
// Service Approve work flow
workflowProcessService.approveWorkflowProcess = function (data) {
  return lossClient({
    url: "/ProductWorkFlow/Approve",
    method: "put",
    headers: {
      "x-RequestId": data.id,
    },
    data: {
      Note: data.note,
    },
  });
};
// Service Request work flow
workflowProcessService.requestWorkflowProcess = function (data) {
  return lossClient({
    url: "/ProductWorkFlow/Request",
    method: "put",
    headers: {
      "x-RequestId": data.id,
    },
    data: {
      Request: data.request,
      note: data.note,
    },
  });
};

export default workflowProcessService;
